import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAnalytics, useBots } from "@/features/bots/hooks";

export function DashboardPage() {
  const { t } = useTranslation(["bots", "common"]);
  const { data: bots, isLoading: botsLoading } = useBots();
  const { data: analytics, isLoading: analyticsLoading } = useAnalytics();

  const activeBots = bots?.filter((b) => b.status === "active").length ?? bots?.length ?? 0;

  const cards = [
    { label: t("bots:dashboard.cards.activeBots"), value: botsLoading ? "…" : String(activeBots) },
    {
      label: t("bots:dashboard.cards.conversations"),
      value: analyticsLoading ? "…" : String(analytics?.current.conversations ?? 0),
    },
    {
      label: t("bots:dashboard.cards.messages"),
      value: analyticsLoading ? "…" : String(analytics?.current.messages ?? 0),
    },
    {
      label: t("bots:dashboard.cards.aiCalls"),
      value: analyticsLoading ? "…" : String(analytics?.current.ai_calls ?? 0),
    },
  ];

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">{t("bots:dashboard.title")}</h1>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <div key={c.label} className="card">
            <div className="card-body">
              <p className="text-xs uppercase text-slate-500">{c.label}</p>
              <p className="mt-2 text-3xl font-semibold">{c.value}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-body flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
          <div>
            <h2 className="text-base font-semibold">{t("bots:dashboard.getStartedTitle")}</h2>
            <p className="text-sm text-slate-500">{t("bots:dashboard.getStartedDescription")}</p>
          </div>
          <Link to="/bots" className="btn-primary">
            {t("bots:dashboard.manageBots")}
          </Link>
        </div>
      </div>
    </div>
  );
}
